// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2atwD","content":"styles_content__JjaIK","nav":"styles_nav__5nJhG"};